module.exports = __webpack_public_path__ + "img/announciator.aaab0501.png";